export default __webpack_public_path__ + "static/media/imatge-slider-portada-2.a6aed8f2.jpg";